<template>
  <div>
    <h3>
      <span>{{ $t('message.script_config_time') | title }}</span>
      <span class="wiki-link">
        <a :href="$t('message.script_config_time_doc_link')" target="_blank">
          WIKI
        </a>
      </span>
    </h3>

    <div v-if="willRunOnEachClusterNode" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <b-form v-if="timeConfig">
      <b-form-row v-if="timezoneOptions">
        <div class="col-4 label label-default">{{ $t("message.time_timezone") | title }}</div>
        <div class="col-8">
          <b-form-input list="tz-list" v-model="timeConfig.timezone.value" onfocus="this.value=''" onchange="this.blur()"></b-form-input>
          <b-form-datalist id="tz-list" :options="timezoneOptions"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4 label label-default">{{ $t("message.time_ntp_servers") | title }}</div>
        <div class="col-8">
          <tags-input element-id="server-tags" ref="time-server-tags" v-model="timeConfig.ntp_servers.value"
            :add-tags-on-comma="true" :typeahead="false" placeholder="" :add-tags-on-blur="true"/>
        </div>
      </b-form-row>

      <b-form-row id="server-time-row">
        <div class="col-3 label label-default">
          {{ $t("message.time_status") | title }}
        </div>
        <div class="col-8">
          <pre>
            {{timeStatus}}
          </pre>
        </div>
      </b-form-row>

      <b-button class="padmin-button submit-button" variant="primary" @click="save" :disabled="saveInProgress">
        <b-spinner v-if="saveInProgress" small type="grow"/>
        {{$t('message.button_save') | title}}
      </b-button>
    </b-form>

    <b-alert v-model="showHttpError" variant="danger" dismissible
      @dismissed="httpError=''; showHttpError=false;">
      <div>
        {{ httpError }}
      </div>
      <div v-if="httpErrorRemark">
        {{ httpErrorRemark }}
      </div>
    </b-alert>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>
  </div>
</template>
<script>
import {fromKeyValueToArray, arrayToKeyValue} from '../util'
import { get, post } from '../http'
import ConsoleOutput from './ConsoleOutput'

export default {
  name: 'TimeConfig',

  components: { ConsoleOutput },

  props: {},

  data () {
    return {
      timeConfig: null,
      timezoneOptions: [],
      result: null,
      output: '',
      saveInProgress: false,
      timeStatus: '',
      showHttpError: false,
      httpError: ''
    }
  },

  mounted () {
    this.load()
  },

  methods: {
    getUrl () {
      return '/scripts/config/time'
    },

    load () {
      get(this.getUrl()).then(
        resp => {
          this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
          this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
          this.timeConfig = resp.data.params
          this.timeConfig.ntp_servers.value = arrayToKeyValue(this.timeConfig.ntp_servers.value)
        },
        err => {
          console.log('err', err)
        }
      )

      get('/timezones').then((resp) => {
        this.timezoneOptions = resp.data
        if (this.timeConfig.timezone.value) {
          this.timeConfig.timezone.value = this.timezoneOptions.find(tz => {
            return tz.startsWith(this.timeConfig.timezone.value)
          })
        }
      }, err => {
        console.log('err', err)
      })

      get('/time_status').then((resp) => {
        this.timeStatus = resp.data
      }, err => {
        console.log('err', err)
      })
    },

    save () {
      this.result = null
      this.output = ''
      this.saveInProgress = true
      this.showHttpError = false
      this.httpError = ''

      let data = JSON.parse(JSON.stringify(this.timeConfig))
      data.ntp_servers.value = fromKeyValueToArray(data.ntp_servers.value)
      data.timezone.value = data.timezone.value.split('(')[0].trim()

      post(this.getUrl(), data, { 'Content-Type': 'application/json' }).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.saveInProgress = false

          if (this.result && resp.data.padmin_restart_required) {
            this.$root.$emit("bv::show::modal", "padmin-restart-modal-id")
          }

          setTimeout(() => {
            if (this.result && resp.data.agung_restart_required) {
              this.$root.$emit("bv::show::modal", "passman-restart-modal-id")
            }
          }, 100)

          get('/time_status').then((resp) => {
            this.timeStatus = resp.data
          }, err => {
            console.log('err', err)
          })
        },
        err => {
          console.log('err', err)
          this.saveInProgress = false
          if (err.response && err.response.status != 409) {
            this.httpError = 'HTTP ERROR:' + err.response.status + ' ' + err.response.statusText
            this.showHttpError = true
          }
        }
      )
    }
  }
}
</script>
<style scoped>
  .form-control {
    margin: 10px 0 !important;
  }
  .custom-select {
    border-radius: 0 !important;
  }
  #server-time-row{
    width:140%;
  }
</style>
